import { render, staticRenderFns } from "./YoutubeConfig.vue?vue&type=template&id=2200f8b9&scoped=true&"
import script from "./YoutubeConfig.vue?vue&type=script&lang=js&"
export * from "./YoutubeConfig.vue?vue&type=script&lang=js&"
import style0 from "./YoutubeConfig.vue?vue&type=style&index=0&id=2200f8b9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2200f8b9",
  null
  
)

export default component.exports